import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "picture-viewer-bar" }
const _hoisted_2 = { class: "swiper" }
const _hoisted_3 = { class: "swiper-wrapper" }
const _hoisted_4 = { class: "swiper-zoom-container" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["picture-viewer-wrapper", [_ctx.isLeaving && 'leave']]),
    "on:webkieAnimationend": _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.destroy && _ctx.destroy(...args))),
    onAnimationend: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.destroy && _ctx.destroy(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString(_ctx.curIndex + 1) + " / " + _toDisplayString(_ctx.list.length), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["scale", [_ctx.isBig && 'big']]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scaleToggle && _ctx.scaleToggle(...args)))
      }, null, 2),
      _createElementVNode("span", {
        class: "close",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "swiper-slide",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: item.img,
                alt: ""
              }, null, 8, _hoisted_5)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["prev btn", [_ctx.list.length < 2 && 'disabled']]),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["next btn", [_ctx.list.length < 2 && 'disabled']]),
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
      }, null, 2)
    ])
  ], 34))
}